export const UPDATE_SETTING_REQUEST = 'UPDATE_SETTING_REQUEST'
export const UPDATE_SETTING_SUCCESS = 'UPDATE_SETTING_SUCCESS'
export const UPDATE_SETTING_FAIL = ' TUPDATE_SETTING_FAIL'
export const UPDATE_SETTING_RESET = 'UPDATE_SETTING_RESET'

export const LIST_SETTING_REQUEST = 'LIST_SETTING_REQUEST'
export const LIST_SETTING_SUCCESS = 'LIST_SETTING_SUCCESS'
export const LIST_SETTING_FAIL = 'LIST_SETTING_FAIL'
export const LIST_SETTING_RESET = 'LIST_SETTING_RESET'